import React, { useEffect, useState, useRef, useMemo } from 'react';
import Footer from '../../layout/footer/footer';
import './payment.css';
import Beard from '../../assets/images/logo-beard2.svg';
import Accordion from 'react-bootstrap/Accordion';
import { Form } from 'react-bootstrap';
import { getCity, getProvince, getUserInfo, getBasketList } from '../../utils/api';
import Loader from '../../components/loader/dotloader'
import LoaderBtn from '../loader/loader'
import { Toast } from 'primereact/toast';
import { buyCard } from '../../utils/api'
import { Sidebar } from 'primereact/sidebar';
import ArrowDown from '../../assets/icons/select-arrow-down.svg'
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import useToastNotification from '../../hooks/useToastNotification';
import { useCart } from '../../contexts/CartContext';

function Payment() {
    const dispatch = useDispatch();
    const [provinceList, setProvinceList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [settings, setSettings] = useState(null);
    const [deliveryPrice, setDeliveryPrice] = useState(null);
    const toast = useRef(null);
    const [validated, setValidated] = useState(false);
    const userPaymentInfo = useSelector(state => state.userPaymentInfo);
    const { addToCart } = useCart();
const sentBeginRef = useRef(false); // جلوگیری از ارسال تکراری begin_checkout


    // Receiver info
    const [province, setProvince] = useState('');
    const [city, setCity] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [address, setAddress] = useState('');
    const [plate, setPlate] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [mobile, setMobile] = useState('');
    const [unit, setUnit] = useState('');
    const [loading, setLoading] = useState(true);
    const [visibleProvince, setVisibleProvince] = useState(false);
    const [visibleCity, setVisibleCity] = useState(false);
    const [items, setItems] = useState([]);
    // هزینه پست
    const [shippingCost, setShippingCost] = useState(0);
    // محاسبه مبلغ کل و تعداد کل کالاها
    const totalPrice = items.reduce((acc, item) => acc + (item.price * item.count), 0);
    const taxRate = settings?.tax ?? 0;
    const packaginCost_setting = settings?.packagingCost ?? 0;
    const numberPerPackaging = settings?.numberPerPackaging ?? 0;
    const taxAmount = totalPrice * taxRate / 100
    const totalCount = items.reduce((acc, item) => acc + item.count, 0);
    const packaginCost = Math.ceil(totalCount / numberPerPackaging) * packaginCost_setting
    // محاسبه مبلغ نهایی شامل هزینه پست
    const finalTotalPrice = totalPrice + (deliveryPrice ?? 0) + taxAmount + packaginCost;
    const yaldaProductIds = [84470,84471,84472];
    // وقتی کاربر وارد فرایند خرید شد (سبد بارگذاری شد)، begin_checkout را یک بار ارسال کن
useEffect(() => {
  if (sentBeginRef.current) return;                       // قبلاً ارسال شده؟
  if (!Array.isArray(items) || items.length === 0) return;
  if (typeof window.gtag !== 'function') return;

  // مپ ایمن آیتم‌ها برای GA4
  const gaItems = items.map((it) => ({
    item_id: String(it.id ?? it.productId ?? it.cardId ?? it.code ?? 'unknown'),
    item_name: it.title ?? it.name ?? 'Gift Card',
    item_category: it.categotyTitle ?? it.categoryTitle ?? '',
    price: Number(it.price) || 0,       // تومان
    quantity: Number(it.count) || 1,
  }));

  // مجموع ارزش سبد (بدون مالیات/ارسال) برای begin_checkout
  const value = gaItems.reduce((sum, i) => sum + (i.price * i.quantity), 0);

  window.gtag('event', 'begin_checkout', {
    currency: 'IRT',     // تومان (نه IRR)
    value,
    items: gaItems,
    debug_mode: true,    // برای نمایش فوری در DebugView (بعداً می‌تونی حذف کنی)
  });

  sentBeginRef.current = true;
}, [items]);

    const hidee = 'hidden' //configMessage == '' ? "hidden" : ""
    const { showError, showSuccess } = useToastNotification();

    // // انتخاب هزینه ارسال
    // const handleShippingCostChange = (cost) => {
    //     setShippingCost(settings.priceSefareshi);
    // };

    const getCities = async (selectedProvince) => {
        try {
            const res = await getCity(selectedProvince); // Assume getCity can take province as argument
            setCityList(res.data.data);
        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
        }

    };

    const getProvinces = async () => {
        setLoading(true);
        try {
            const res = await getProvince();
            setProvinceList(res.data.data);
            setLoading(false);

        } catch (error) {
            let message = {
                text: 'خطا در ارتباط با سرور'
            }
            showError(message)
            setLoading(false);

        }

    };

    const getBasketData = async () => {
        let productData = await getBasketList(localStorage.getItem('clientId'))

        console.log(productData)
        if (productData) {
            setItems(productData.data.data);
        }
    }
    useEffect(() => {
        if (!province || !settings) return;

        
        const totalCount = items
                .filter(item => yaldaProductIds.includes(item.productId))
                .reduce((sum, item) => sum + item.count, 0);

        if(totalCount > 0)
        {
           setDeliveryPrice((Math.floor((totalCount - 1) / 10)+1) * 250000)
           
        }
        else{
            const TEHRAN_ID = 21;

            const selectedProvinceId = typeof province === 'object' ? province.id : parseInt(province);

            if (selectedProvinceId === TEHRAN_ID) {
                setDeliveryPrice(settings.pricePeyk);
            } else {
                setDeliveryPrice(settings.priceSefareshi);
            }
        }
    }, [province, settings]);
    useEffect(() => {
        getProvinces();
        getBasketData()
        setTimeout(() => {

            setSettings(JSON.parse(localStorage.getItem('settings')));
            initialUserPaymentInfo();

        }, 1000);
    }, []);

    const setLocalPaymentData = (info) => {
        setAddress(info.address);
        setFirstName(info.firstName);
        setLastName(info.lastName);
        setMobile(info.mobile);
        setProvince(info.province);
        setCity(info.city);
        setPlate(info.plate);
        setUnit(info.unit);
        setPostalCode(info.postalCode);
    };
    const initialUserPaymentInfo = async () => {
        if (!!userPaymentInfo) {
            // read the pre-editted payment info from local storage
            let info = JSON.parse(userPaymentInfo);
            setLocalPaymentData(info);
        }
        else {

            let res = await getUserInfo();
            let data = res?.data?.data;
            if (!!data) {
                // use the preset user info in panel
                let info = {
                    address: data.address,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    mobile: data.phone,
                    province: data.provinceId,
                    city: data.cityId,
                    plate: '',
                    unit: '',
                    postalCode: data.postalCode,
                }
                setLocalPaymentData(info);
                dispatch({ type: "SET_USER_PAYMENT_INFO", payload: info });
            }
            else {
                let info = {
                    address: '',
                    firstName: '',
                    lastName: '',
                    mobile: '',
                    province: '',
                    city: '',
                    plate: '',
                    unit: '',
                    postalCode: '',
                }
                dispatch({ type: "SET_USER_PAYMENT_INFO", payload: info });
            }
        }
    };
    useEffect(() => {
        if (!firstName && !lastName && !mobile && !province && !city && !address && !plate && !unit && !postalCode) {
            // reject empty call
            return;
        }
        setUserPaymentInfo();
    }, [firstName, lastName, mobile, province, city, address, plate, unit, postalCode]);
    const setUserPaymentInfo = () => {
        let info = {
            address,
            firstName,
            lastName,
            mobile,
            province,
            city,
            plate,
            unit,
            postalCode,
        }
        dispatch({ type: "SET_USER_PAYMENT_INFO", payload: info });
    };

    useEffect(() => {
        if (province) {
            if (typeof province === 'object' && Object.keys(province).length > 0) {

                getCities({ provinceId: province.id });
            } else {
                getCities({ provinceId: province });

            }
        }
    }, [province]); // Fetch cities when province changes



    
    const [btnLoading, setBtnLoading] = useState(false);
    const submitOrder = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === true) {
            try {
                const existsYaldaCount = items.some(
                item => yaldaProductIds.includes(item.productId) && item.count < 10
                );

                if(existsYaldaCount)
                {
                    setBtnLoading(false)
                    showError({ text: 'تعداد محصولات یلدا نباید کمتر از 10 عدد باشد' })
                    return;
                }

                setBtnLoading(true)
                let pay = {
                    cards: items,
                    receiverName: firstName + ' ' + lastName,
                    receiverAddress: address,
                    receiverOstanID: typeof province === 'object' && Object.keys(province).length > 0 ? province.id : province,
                    receiverShahrID: typeof city === 'object' && Object.keys(city).length > 0 ? city.id : city,
                    receiverPhone: mobile,
                    receiverCodePostal: postalCode,
                    description: '',
                    plateNumber: plate,
                    unitNumber: unit,
                    totalAmount: finalTotalPrice,
                    clientId: localStorage.getItem('clientId')
                }
                let res = await buyCard(pay)

                setBtnLoading(true)
                if (res.data.isSuccess) {

                    // localStorage.setItem('orderId', res.data.data.orderId)
                    let message = {
                        text: 'درحال انتقال به درگاه پرداخت...'
                    }
                    showSuccess(message)

                    // delete reciever info from localStorage
                    // dispatch({ type: "SET_USER_PAYMENT_INFO", payload: null });
                    setBtnLoading(true)

                    window.location.replace(res.data.data.urlRedirect)
                }
                else {
                    setBtnLoading(false)
                    showError({ text: res.data.message })
                }
            } catch (error) {
                setBtnLoading(false)
                let message = {
                    text: 'خطا در برقرای با سرور'
                }
                showError(message)
            }

        }
        setValidated(true);

    }

    const provinceTitle = useMemo(() => {
        try {
            if (province && provinceList) {
                return provinceList.find(item => item.id === province).title;
            }
            else {
                return '';
            }
        } catch (error) {

        }
    }, [province]);

    const cityTitle = useMemo(() => {
        try {
            if (city && provinceList) {
                return cityList.find(item => item.id === city).title;
            }
            else {
                return '';
            }
        } catch (error) {

        }
    }, [city]);
    return (
        <div>
            <Toast ref={toast} />
            {loading && <Loader isLoading={loading} />}
            <div className='container payment-body'>
                <div className='d-flex align-items-center title gap-3 '>
                    <img src={Beard} alt="" />آدرس و زمان ارسال
                </div>
                <Form noValidate validated={validated} onSubmit={(e) => submitOrder(e)}>
                    <div className='row mt-3 gy-3 peyment-card'>
                        <div className='col-md-8 col-sm-12'>
                            <Accordion defaultActiveKey={['0']} alwaysOpen>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header className='font-bold text-xl'>اطلاعات گیرنده</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="text-sm font-bold">
                                            <div className="flex gap-2 align-items-start flex-col-dir">
                                                <Form.Group controlId="firstName" className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>نام <span className='text-[red]'> * </span></Form.Label>
                                                    <Form.Control type="text" required value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا نام را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group controlId="lastName" className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>نام خانوادگی <span className='text-[red]'> * </span></Form.Label>
                                                    <Form.Control type="text" required value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا نام خانوادگی را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="flex gap-2 align-items-start">
                                                <Form.Group controlId="mobile" className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>شماره تماس <span className='text-[red]'> * </span></Form.Label>
                                                    <Form.Control className='number' type="number" inputMode="numeric" required value={mobile} onChange={(e) => setMobile(e.target.value)} />
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا شماره تماس را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="flex gap-2 align-items-start">

                                                <Form.Group controlId="province" className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>استان <span className='text-[red]'> * </span></Form.Label>
                                                    <div className='mobile'>

                                                        <div className='input-icon '>
                                                            <Form.Control value={provinceTitle}
                                                                placeholder='انتخاب استان'
                                                                onClick={(e) => {
                                                                    e.preventDefault(); // جلوگیری از باز شدن لیست
                                                                    setVisibleProvince(true); // نمایش Sidebar
                                                                }}
                                                                readOnly />
                                                            <img src={ArrowDown} alt="" />
                                                        </div>
                                                    </div>
                                                    <Sidebar
                                                        header="استان"
                                                        visible={visibleProvince}
                                                        position="bottom"
                                                        onHide={() => setVisibleProvince(false)}
                                                    >
                                                        <div className="prepared-text-options">
                                                            {provinceList.map((item, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`prepared-text-item ${province === item.id ? 'selected' : ''}`}
                                                                    onClick={() => {
                                                                        setProvince(item.id);
                                                                        isMobile === true && setVisibleProvince(false); // Close sidebar on selection
                                                                    }}
                                                                    style={{
                                                                        padding: '10px',
                                                                        borderBottom: '1px solid #eee',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    {item.title}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Sidebar>
                                                    <Form.Select required value={province} onChange={(e) => setProvince(e.target.value)} className="web">

                                                        <option value="" hidden>انتخاب استان</option>
                                                        {provinceList.map(item => (

                                                            <option key={item.id} value={item.id}>{item.title}</option>

                                                        ))}


                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا استان را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group controlId="city" className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>شهر <span className='text-[red]'> * </span></Form.Label>
                                                    <div className='mobile'>
                                                        <div className='input-icon '>
                                                            <Form.Control value={cityTitle}
                                                                placeholder='انتخاب شهر'
                                                                onClick={(e) => {
                                                                    e.preventDefault(); // جلوگیری از باز شدن لیست
                                                                    if (!!province) {
                                                                        isMobile === true && setVisibleCity(true); // نمایش Sidebar
                                                                    }
                                                                }}
                                                                readOnly />
                                                            <img src={ArrowDown} alt="" />
                                                        </div>
                                                    </div>
                                                    <Sidebar
                                                        header="شهر"
                                                        visible={visibleCity}
                                                        position="bottom"
                                                        onHide={() => setVisibleCity(false)}
                                                    >
                                                        <div className="prepared-text-options">
                                                            {cityList.map((item, index) => (
                                                                <div
                                                                    key={index}
                                                                    className={`prepared-text-item ${city === item.id ? 'selected' : ''}`}
                                                                    onClick={() => {
                                                                        setCity(item.id);
                                                                        setVisibleCity(false); // Close sidebar on selection
                                                                    }}
                                                                    style={{
                                                                        padding: '10px',
                                                                        borderBottom: '1px solid #eee',
                                                                        cursor: 'pointer',
                                                                    }}
                                                                >
                                                                    {item.title}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </Sidebar>
                                                    <Form.Select className='web' required value={city} onChange={(e) => setCity(e.target.value)}
                                                        disabled={!province}>
                                                        <option value="" hidden>انتخاب شهر</option>
                                                        {cityList.map(item => (
                                                            <option key={item.id} value={item.id}>{item.title}</option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا شهر را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="flex gap-2 align-items-start">
                                                <Form.Group controlId="address" className="mb-3 w-2/3 max-md:!w-full">
                                                    <Form.Label>آدرس <span className='text-[red]'> * </span></Form.Label>
                                                    <Form.Control type="text" className='number' required value={address} onChange={(e) => setAddress(e.target.value)} />
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا آدرس را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="flex gap-2 align-items-start">
                                                <Form.Group controlId="plate" className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>پلاک <span className='text-[red]'> * </span></Form.Label>
                                                    <Form.Control className='number' type="number" inputMode="numeric" required value={plate} onChange={(e) => setPlate(e.target.value)} />
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا پلاک را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group controlId="unit" className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>واحد <span className='text-[red]'> * </span></Form.Label>
                                                    <Form.Control className='number' type="number" inputMode="numeric" required value={unit} onChange={(e) => setUnit(e.target.value)} />
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا واحد را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                            <div className="flex gap-2 align-items-start">
                                                <Form.Group className="mb-3 w-1/3 max-md:!w-full">
                                                    <Form.Label>کد پستی <span className='text-[red]'> * </span></Form.Label>
                                                    <Form.Control className='number' type="number" inputMode="numeric" required value={postalCode} onChange={(e) => setPostalCode(e.target.value)} />
                                                    <Form.Control.Feedback type="invalid">
                                                        لطفا کدپستی را وارد کنید
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </div>
                                        </div>

                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1" className='mt-3 d-none'>
                                    <Accordion.Header className='font-bold text-xl'>تنظیمات ارسال</Accordion.Header>
                                    <Accordion.Body>
                                        <div className="my-3 font-bold">
                                            {/* <div>
                                            <label className='flex justify-between'>
                                                <div>
                                                    <Form.Check
                                                        checked
                                                        className='font-bold text-[#242424] text-sm'
                                                        reverse
                                                        inline
                                                        label="پیک فروشگاه"
                                                        name="group1"
                                                        type='radio'
                                                        id='peyk'
                                                        onChange={() => handleShippingCostChange(settings?.pricePeyk)}

                                                    />
                                                    <div className="mr-10 number text-[#4E4E4E] text-sm">
                                                        ارسال بعد از 3 روز کاری
                                                    </div>
                                                </div>
                                                <div className='font-bold number'>
                                                    {parseInt(settings?.pricePeyk).toLocaleString()} تومان
                                                </div>
                                            </label>
                                        </div> */}
                                            <div className='mt-3'>
                                                <label className='flex justify-between'>
                                                    <div>
                                                        <Form.Check
                                                            checked
                                                            className='font-bold text-[#242424] text-sm'
                                                            reverse
                                                            inline
                                                            label="پست"
                                                            name="group1"
                                                            type='radio'
                                                            id='post'
                                                            // onChange={() => handleShippingCostChange(settings?.priceSefareshi)}

                                                        />
                                                    </div>
                                                    <div className='font-bold number'>
                                                        {parseInt(settings?.priceSefareshi).toLocaleString()} تومان
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2" className='mt-3 d-none'>
                                    <Accordion.Header className='font-bold text-xl'>انتخاب روش پرداخت</Accordion.Header>
                                    <Accordion.Body>
                                        <div className='item'>
                                            <label className='flex justify-between align-items-center'>
                                                <Form.Check
                                                    checked
                                                    reverse
                                                    inline
                                                    name="payment"
                                                    type='radio'
                                                    id='parsian'
                                                />
                                                <div className='flex gap-1 align-items-center'>
                                                    <img src={require('../../assets/images/gateways/parsian.svg').default} alt="" />
                                                    <div className='text-[#242424] font-bold'>
                                                        پرداخت از طریق درگاه پارسیان
                                                    </div>
                                                </div>


                                            </label>
                                        </div>
                                        {/* <div className='item'>
                                        <label className='flex justify-between align-items-center'>
                                            <div className='flex gap-1 align-items-center'>
                                                <img src={require('../../assets/images/gateways/melli.svg').default} alt="" />
                                                <div className='text-[#242424] font-bold'>
                                                    پرداخت از طریق درگاه ملی
                                                </div>
                                            </div>
                                            <Form.Check
                                                checked
                                                reverse
                                                inline
                                                name="payment"
                                                type='radio'
                                                id='melli'
                                            />
                                        </label>
                                    </div>
                                    <div className='item'>
                                        <label className='flex justify-between align-items-center'>
                                            <div className='flex gap-1 align-items-center'>
                                                <img src={require('../../assets/images/gateways/saman.svg').default} alt="" />
                                                <div className='text-[#242424] font-bold'>
                                                    پرداخت از طریق درگاه سامان
                                                </div>
                                            </div>
                                            <Form.Check
                                                checked
                                                reverse
                                                inline
                                                name="payment"
                                                type='radio'
                                                id='saman'
                                            />
                                        </label>
                                    </div> */}
                                    </Accordion.Body>
                                </Accordion.Item>
                                {/* <Accordion.Item eventKey="3" className='mt-2'>
                                <Accordion.Header>توضیحات تکمیلی</Accordion.Header>
                                <Accordion.Body>
                                    <Form>

                                        <div className="flex gap-2 align-items-end">
                                            <Form.Group controlId="text" className="mb-3 w-2/3">
                                                <Form.Label>توضیحات تکمیلی</Form.Label>
                                                <Form.Control type="text" />
                                            </Form.Group>
                                        </div>
                                    </Form>
                                </Accordion.Body>
                            </Accordion.Item> */}
                            </Accordion>
                        </div>
                        <div className='col-md-4 col-sm-12'>
                            <div className='bg-[#E5ECFF] rounded-lg p-4' style={{ marginBottom: '6em' }}>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <h6 className='font-semibold text-sm number'>قیمت کالاها ({totalCount}):</h6>
                                    <h6 className='font-semibold text-sm number'>{totalPrice.toLocaleString()} تومان</h6>
                                </div>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <h6 className='font-semibold text-sm number'> مالیات بر ارزش افزوده:</h6>
                                    <h6 className='font-semibold text-sm number'>{taxAmount.toLocaleString()} تومان</h6>
                                </div>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <h6 className='font-semibold text-sm'>هزینه بسته بندی :</h6>
                                    <h6 className='font-semibold text-sm number'>{packaginCost.toLocaleString()}  تومان</h6>
                                </div>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <h6 className='font-semibold text-sm'>هزینه ارسال :</h6>
                                    <h6 className='font-semibold text-sm number'>{deliveryPrice?.toLocaleString()} تومان</h6>
                                </div>
                                <div className='d-flex align-items-center justify-content-between mt-2'>
                                    <h6 className='font-semibold text-sm text-[#0033CC]'>مبلغ نهایی سفارش :</h6>
                                    <h6 className='font-semibold text-sm number text-[#0033CC]'>{finalTotalPrice.toLocaleString()} تومان</h6>
                                </div>
                                <hr />
                                {/* <div className='d-flex align-items-center justify-content-between mt-3'>
                                <h6 className='font-semibold text-sm text-[#0033CC]'>سود شما از خرید:</h6>
                                <h6 className='font-semibold text-sm text-[#0033CC] number'>240.000 تومان</h6>
                            </div> */}
                                <div className='d-flex align-items-center gap-2'>

                                    <button className='btn btn-outline-primary w-100 mt-4' type='button' onClick={() => { window.location.href = '/shopping-cart' }}>مشاهده سبد خرید</button>
                                    <button className='btn btn-primary w-100 mt-4' disabled={btnLoading} type='submit' >  ثبت و پرداخت {btnLoading && <LoaderBtn />} </button>
                                </div>
                                <div className={hidee}>
                                    <hr />
                                    <p className='alert alert-danger f-bold' >
                                        سفارشاتی که از تاریخ 1403/12/19 در سامانه ثبت شوند ، ارسال آنها از تاریخ 1404/01/06 به بعد انجام میگردد
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>

            <div className="home-footer mt-40">
                <Footer />
            </div>
        </div>

    )
}

export default Payment